import * as React from 'react';
import {
  Icon,
  IconName,
  IconScale,
  Typography,
  TypographyVariant,
  useCarouselCurrentSlide,
  useTheme,
} from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { ActionButton, DesktopContainer, MobileContainer } from './GalleryAction.styles';

interface Props {
  onClick: (index?: number) => void;
  totalImages: number;
}

export const GalleryAction = ({ onClick, totalImages }: Props) => {
  const { translations } = useTranslations();
  const theme = useTheme();
  const currentSlide = Number(useCarouselCurrentSlide());

  return (
    <>
      <MobileContainer>
        <ActionButton onClick={() => onClick(currentSlide)}>
          <Typography
            component={'span'}
            variant={TypographyVariant.microBold}
            color={theme.color.white}
          >
            <>
              {currentSlide + 1}/{totalImages}
            </>
          </Typography>
        </ActionButton>
      </MobileContainer>
      <DesktopContainer>
        <ActionButton onClick={() => onClick(undefined)}>
          <Icon name={IconName.solidPhoto} fillColor={theme.color.white} size={IconScale.l} />
          <Typography
            component={'span'}
            variant={TypographyVariant.bodyBold}
            color={theme.color.white}
          >
            <>
              {i18n('sale.photos.viewAll.label', [], translations)} ({totalImages})
            </>
          </Typography>
        </ActionButton>
      </DesktopContainer>
    </>
  );
};
